<div mat-dialog-title class="dialog-header-container">

    <div class="header-content">
        <h2 >{{getSummaryTitle()}}</h2>
        <span class="mat-font-title-md" *ngIf="!formSubmitted">Available for properties in US and Canada</span>
        <span class="mat-font-body-md" *ngIf="!loading">{{getSummaryDescription()}}</span>
    </div>
    <button matIconButton class="close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="loading-container" *ngIf="loading">
        <mat-spinner [diameter]="100" class="preview-loading"></mat-spinner>
    </div>
    <div class="request-summary" [ngClass]="{'request-summary' : !formSubmitted, 'request-summary-disabled' : formSubmitted}" *ngIf="!loading">
        <div class="summary-title">
            <span class="text-title-medium">Request summary</span>
        </div>
        <div class="summary-content">
            <br>
            <div [ngClass]="{'summary-field-name' : !formSubmitted, 'summary-field' : formSubmitted}">
                <span class="left-content"><b>File name:</b></span> <span>{{data.name}}</span>
            </div>
            <div class="summary-field">
                <span class="left-content"><b>Number of properties*:</b></span> <span>{{data.source.features.features.length}} properties</span>
            </div>
            <div class="summary-field">
                <span class="left-content"><b>Product:</b></span>
                <span>
                    <mat-form-field *ngIf="!formSubmitted" class="form-slim">
                        <mat-select placeholder="Select product" [(ngModel)]="productSelected" [disabled]="formSubmitted">
                            <mat-option [value]="parameterTypes.DEFAULT">All attributes (default)</mat-option>
                            <mat-option [value]="parameterTypes.STRUCTURE_GEOMETRY">Building footprints only</mat-option>
                            <mat-option [value]="parameterTypes.STRUCTURE_ATTRIBUTES">Building attributes only</mat-option>
                            <mat-option [value]="parameterTypes.PARCEL_ATTRIBUTES">Property attributes only</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <span *ngIf="formSubmitted">{{productSelected.NAME}}</span>
                </span>
            </div>
        </div>
    </div>
    <span *ngIf="!formSubmitted">* Recommend processing no more than 1000 properties in a single batch.</span>
    <span *ngIf="formSubmitted">* Occasionally, there are properties with no property information available. If this occurs, the resulting file will not show data for that property.</span>

</mat-dialog-content>

<mat-dialog-actions>
    @if (!loading && !formSubmitted) {
        <button (click)="closeDialog()" matButton="elevated" >
            {{"Back"}}
        </button>
        <button (click)="submit()" matButton="elevated"  [disabled]="!productSelected">{{"Review"}}</button>
    } @else if (!loading && formSubmitted) {

        <button (click)="cancel()" matButton="elevated" >
            {{"Cancel"}}
        </button>
        <button (click)="getPropertyInformation(productSelected)" matButton="elevated" [disabled]="!productSelected">{{"Start Processing"}}</button>
    }

</mat-dialog-actions>